module.exports = __webpack_public_path__ + "static/media/about_icon05.9ff78e79.png";